import { makeAutoObservable, toJS } from "mobx";
import { EMPTY_SOLUTION } from "../defaults/solution";
import { EMPTY_USER_PREFERENCES } from "../defaults/user-preferences";
import { EMPTY_WORKSPACE } from "../defaults/workspace";
import type { SolutionModel } from "../types/solution";
import type { UserPreferences } from "../types/user-preferences";
import type { Workspace } from "../types/workspace";

export class ConfigStore {
  public accountId: string = "";
  public solutionId: string = "";
  public engineUrl: string = "";
  public limitsUrl: string = "";
  public accessToken: string = "";
  public smartsuiteBackendUrl: string = "";
  public userPreferences: UserPreferences = EMPTY_USER_PREFERENCES;
  public solution: SolutionModel = EMPTY_SOLUTION;
  public workspace: Workspace = EMPTY_WORKSPACE;
  public baseUrl: string = "";

  constructor() {
    makeAutoObservable(this);
  }

  init(
    accountId: string,
    solutionId: string,
    engineUrl: string,
    limitsUrl: string,
    accessToken: string,
    smartsuiteBackendUrl: string,
    userPreferences: UserPreferences,
    solution: SolutionModel,
    workspace: Workspace,
    baseUrl: string,
  ): void {
    this.accountId = accountId;
    this.solutionId = solutionId;
    this.engineUrl = engineUrl;
    this.limitsUrl = limitsUrl;
    this.accessToken = accessToken;
    this.smartsuiteBackendUrl = smartsuiteBackendUrl;
    this.userPreferences = userPreferences;
    this.solution = toJS(solution);
    this.workspace = workspace;
    this.baseUrl = baseUrl;
  }
}
